import {ReactNode} from 'react';
import {Box, Col, Row} from 'components/Grid';
import style from 'modules/errors/pages/NotFoundPage/style.module.scss';
import TuplesLinks from 'modules/errors/components/TuplesLinks';
import {ERROR_PAGE_LINKS} from 'modules/errors/constants';
import {Typography} from 'components/Typography';
import {Button} from 'components/Button';
import Picture from 'components/Picture';

interface IErrorSectionProps {
    statusCode?: string;
    description: ReactNode;
    buttonText: string;
    href?: string;
    onClick?: () => void;
}

const ErrorSection = ({statusCode, description, buttonText, href, onClick}: IErrorSectionProps) => {
    return (
        <Box>
            <Row className={style.errorSection}>
                <Col>
                    <TuplesLinks limit={8} linkList={ERROR_PAGE_LINKS} />
                </Col>
                <Col className={style.contentWrap} lg={10} md={12} sm={12} xl={10}>
                    <Row className={style.content}>
                        <Col lg={5} md={6} sm={12}>
                            <div className={style.descriptionBlock}>
                                {statusCode && (
                                    <Typography className={style.title} variant={'h1'}>
                                        {statusCode}
                                    </Typography>
                                )}
                                <div className={style.textWrap}>
                                    <Typography className={style.subTitle} variant={'h2-medium'}>
                                        Упс!
                                    </Typography>
                                    <div>
                                        <Typography variant={'price-preview-l'}>{description}</Typography>
                                    </div>
                                </div>
                                <Button href={href} onClick={onClick}>
                                    {buttonText}
                                </Button>
                            </div>
                        </Col>
                        <Col lg={7} md={6} sm={12}>
                            <Picture alt={'error'} sources={{}} src={'/images/errors/page-error.webp'} />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Box>
    );
};

export default ErrorSection;
